// Copyright 2018 Sorama B.V.

import { Range as IRange } from "datatypes/SoramaLocalApi";
import { Frequency } from "units/Frequency";

export class FileNameConversion {
    public static convertToString(...label): string {
        const labelsCombined: string[] = [];

        for (let i = 0; i < label.length; i++) {
            if (Array.isArray(label[i]) && label[i].length > 1) {
                for (let ii = 0; ii < label[i].length; ii++) {
                    labelsCombined.push(label[i][ii]);
                }
            } else {
                labelsCombined.push(label[i]);
            }
        }
        return labelsCombined.join("_");
    }

    public static convertSelectedFrequencies(currentlySelectedFrequencies: IRange[]): string {
        const currentlySelectedFreqs: string[] = [];

        if (currentlySelectedFrequencies) {
            for (let i = 0; i < currentlySelectedFrequencies.length; i++) {
                currentlySelectedFreqs.push(
                    currentlySelectedFrequencies[i].from.toFixed(0) +
                        "-" +
                        currentlySelectedFrequencies[i].to.toFixed(0) +
                        Frequency.hertz.unit
                );
            }
        }

        return currentlySelectedFreqs.join("_");
    }
}
